import React from "react";
import { useLocation } from "react-router-dom";

const WA_NUMBER = "447413409256";
const WA_MESSAGE = "Hi PRO ACCOUNTANTS, I'd like to ask about your services";
const WA_LINK = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;

export const WhatsAppButton = () => {
  const { pathname } = useLocation();
  // On the public enquiry form (mobile), lift it above the sticky "Get a quote" bar.
  const pos = pathname === "/enquire" ? "bottom-24 right-4 sm:bottom-6 sm:right-6" : "bottom-6 right-4 sm:right-6";
  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className={`fixed ${pos} z-[60] grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/25 ring-1 ring-black/5 transition-transform duration-200 hover:scale-110 active:scale-95`}
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-40" />
      <svg viewBox="0 0 32 32" className="relative h-7 w-7" fill="currentColor" aria-hidden="true">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.49 1.126 6.73 3.04 9.37L1.05 31.28l6.11-1.954A15.9 15.9 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0Zm9.31 22.593c-.386 1.09-1.92 1.994-3.142 2.258-.836.178-1.928.32-5.604-1.204-4.7-1.948-7.726-6.724-7.962-7.034-.226-.31-1.9-2.53-1.9-4.826 0-2.296 1.206-3.424 1.634-3.89.386-.42.88-.59 1.18-.59.33 0 .62.004.868.016.278.014.65-.106 1.016.776.386.924 1.312 3.192 1.428 3.424.116.232.194.504.038.814-.146.31-.274.504-.504.776-.232.272-.486.608-.696.814-.232.232-.472.484-.202.95.27.465 1.2 1.98 2.576 3.206 1.77 1.578 3.264 2.068 3.73 2.3.466.232.736.194 1.006-.116.27-.31 1.156-1.35 1.464-1.814.31-.465.62-.388 1.044-.232.426.154 2.704 1.276 3.17 1.508.465.232.775.348.89.542.116.194.116 1.12-.27 2.21Z" />
      </svg>
    </a>
  );
};
